export { default as SparklesOutlineIcon } from './SparklesOutlineIcon';
